export default defineNuxtPlugin({
  name: 'orders-root',
  dependsOn: ['auth-loader:plugin'],
  async setup(nuxtApp) {
    const { support } = useOrder()

    if (import.meta.client) {
      support.loadItemsForOrder()
    }
  },
})
